import React from 'react';
import { FieldPath } from 'react-hook-form';
import { ItableColumn } from 'components/Table/type';
import { EnumMasterSort } from 'view/Layout/enum';
import {
  EnumDetail,
  EnumQueryResults,
  EnumMaster,
  IqueryResults,
  RcvQueryForm,
} from './init';

export const getColumns = (controlData: IqueryResults): ItableColumn[] => {
  return [
    {
      title: '',
      field: 'selected',
      show: controlData[EnumQueryResults.checkbox],
    },

    {
      title: '項次',
      field: 'itemNo',
    },
    {
      title: '體系別',
      field: EnumDetail.retailerName,
      show: controlData[EnumQueryResults.retailerId],
    },
    {
      title: (
        <div>
          分店
          <br />
          倉庫名稱
        </div>
      ),
      field: EnumDetail.buyerGln,
      show: controlData[EnumQueryResults.storeNo],
      dataTitle: '分店倉庫名稱',
    },
    {
      title: '驗收單號碼',
      field: EnumDetail.receiveNo,
      show: controlData[EnumQueryResults.receiveNo],
    },
    {
      title: '驗收日期',
      field: EnumDetail.deliverDate,
      show: controlData[EnumQueryResults.receiveDate],
    },
    {
      title: '進貨日期',
      field: EnumDetail.arriveDateTime,
      show: controlData[EnumQueryResults.arriveDateTime],
    },
    {
      title: '備註',
      field: EnumDetail.remark,
      show: controlData[EnumQueryResults.remark],
    },
    {
      title: '廠編',
      field: EnumDetail.supplierCode,
      show: controlData[EnumQueryResults.supplierCode],
    },
    {
      title: '廠商簡稱',
      field: EnumDetail.supplierBriefName,
      show: controlData[EnumQueryResults.supplierBriefName],
    },
    {
      title: '訂單號碼',
      field: EnumDetail.orderNo,
      show: controlData[EnumQueryResults.orderNo],
    },
    {
      title: '訂單日期',
      field: EnumDetail.orderDate,
      show: controlData[EnumQueryResults.orderDate],
    },
    {
      title: '驗收單狀態',
      field: EnumDetail.sourceState,
      show: controlData[EnumQueryResults.receiveStatus],
    },
    {
      title: '結帳日',
      field: EnumDetail.closeDate,
      show: controlData[EnumQueryResults.closeDate],
    },
    {
      title: '送貨結束日期',
      field: EnumDetail.deliverEndDate,
      show: controlData[EnumQueryResults.deliverEndDate],
    },
    {
      title: '結帳月份',
      field: EnumDetail.billMonth,
      show: controlData[EnumQueryResults.billMonth],
    },
    {
      title: '點閱紀錄',
      field: EnumDetail.viewed,
      show: controlData[EnumQueryResults.viewed],
    },
    {
      title: (
        <div>
          文字檔
          <br />
          下載紀錄
        </div>
      ),
      field: EnumDetail.downloaded,
      show: controlData[EnumQueryResults.downloaded],
      dataTitle: '文字檔下載紀錄',
    },
    {
      title: '最後異動時間',
      field: EnumDetail.updDate,
      show: controlData[EnumQueryResults.updDate],
    },
  ];
};

export const nameMaster = (
  field: FieldPath<typeof EnumMaster>,
): FieldPath<RcvQueryForm> => `master.${field}`;

export const nameMasterSort = (
  field: EnumMasterSort,
  rowIdx: number,
): FieldPath<RcvQueryForm> => `masterSort.${rowIdx}.${field}`;

/** 排序選項 */
export const propertyOption = [
  { label: '未排序', value: '' },
  { label: '驗收單號碼', value: 'receiveNo' },
  {
    label: '驗收單日期',
    value: 'deliverDate',
  },
  {
    label: '訂單號碼',
    value: 'orderNo',
  },
  {
    label: '分店/倉庫代碼',
    value: 'buyerGLN',
  },
];
